import { OPERATION_TYPE, OperationType, QuoteAcceptData } from "interfaces";
import { SMS_CODE_RETRY_DELAY_IN_SECONDS } from "./envConstants";
import { BID_OPERATION_PATH, ENDPOINTS, RelevantOperationType } from "services";

const LAST_SMS_KEY = "lastSmsSentTime";
const MESSAGE_KEY = "lastSmsMessage";
const SIGNATURE_KEY = "lastSmsSignature";

export const canSendSms = (operation: OperationType): boolean => {
  const lastSentTime = localStorage.getItem(`${LAST_SMS_KEY}_${operation}`);
  if (!lastSentTime) return true;

  const now = Date.now();
  return now - Number(lastSentTime) >= SMS_CODE_RETRY_DELAY_IN_SECONDS * 1000;
};

export const getLastSentTime = (operation: OperationType): number => {
  const lastSentTime = localStorage.getItem(`${LAST_SMS_KEY}_${operation}`);
  if (!lastSentTime) return 0;

  const now = Date.now();
  const diff = Math.ceil((SMS_CODE_RETRY_DELAY_IN_SECONDS * 1000 - (now - Number(lastSentTime))) / 1000);
  return diff > 0 ? diff : 0;
};

export const markSmsSend = (operation: OperationType, message: string, signature?: string): void => {
  localStorage.setItem(`${LAST_SMS_KEY}_${operation}`, Date.now().toString());
  localStorage.setItem(`${MESSAGE_KEY}_${operation}`, message);
};

export const getLastSmsData = (
  operation: Exclude<OperationType, "SIGNATURE">,
  signature?: string
): { message: string; signature?: string } | null => {
  const message = localStorage.getItem(`${MESSAGE_KEY}_${operation}`);
  return message ? { message } : null;
};

export const clearSmsData = (operation: OperationType): void => {
  localStorage.removeItem(`${MESSAGE_KEY}_${operation}`);
  localStorage.removeItem(`${SIGNATURE_KEY}_${operation}`);
};

export function getBidOperationEndpoint(params: {
  id: string;
  operationType: RelevantOperationType;
  quoteRequestData?: QuoteAcceptData;
}): string {
  const { id, operationType, quoteRequestData } = params;

  if (quoteRequestData?.quoteRequest && quoteRequestData.quoteId) {
    return ENDPOINTS.quoteIdAccept(quoteRequestData.quoteId);
  }

  if (operationType === OPERATION_TYPE.RUB_WITHDRAWAL_REQUEST) {
    return ENDPOINTS.rubWithdrawalRequest();
  }

  if (operationType === OPERATION_TYPE.VERIFY_WALLET_QUOTE) {
    return ENDPOINTS.verifyWalletQuote(id);
  }

  if (operationType === OPERATION_TYPE.NOMINAL_ACCOUNT_DEPOSIT) {
    return ENDPOINTS.rubOperationDeposit();
  }

  return ENDPOINTS.bidOperation({ operation: BID_OPERATION_PATH[operationType], id });
}
